module.exports = __webpack_public_path__ + "static/40gde-a56a5834709a4b87e0014e86c68e1a38.gif";